import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQueryFesRequest } from '../../../api/fesRequest/baseQueryFesRequest.service';

export const apiSlice = createApi({
  reducerPath: 'api',
  baseQuery: baseQueryFesRequest,
  endpoints: () => ({}),
});
